// Copyright (c) 2022 by Move Closer

import { MappingConfig } from '@movecloser/front-core'

import { FileRelatedType } from '../../media/related.types'

import { logger } from '../../../support'

import {
  AbstractTypeDriver,
  AnyDescription,
  DriverConfig,
  RelatedRecord,
  RelatedType,
  ResolvesDriver
} from '../../shared'

import { CategoryData, DescriptionOfCategory } from '../contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class CategoryDriver extends AbstractTypeDriver<DescriptionOfCategory, CategoryData> {
  protected adapterMap: MappingConfig = {}
  protected dependencies: RelatedType[] = [FileRelatedType]
  protected key: RelatedType = CategoryRelatedType

  /**
   * @inheritDoc
   */
  protected resolveNested (
    unresolved: DescriptionOfCategory,
    record: RelatedRecord,
    config: DriverConfig,
    driverResolver?: ResolvesDriver
  ): AnyDescription {
    if (typeof driverResolver === 'undefined') {
      throw new Error('[ProductRelatedType]: Missing driverResolver.')
    }

    let logo
    if (unresolved.logo) {
      try {
        const fileDriver = driverResolver(FileRelatedType)
        logo = fileDriver.resolve(`${unresolved.logo.value}`, record, config)
      } catch (e) {
        logger(e, 'warn')
      }
    }

    return {
      ...unresolved,
      logo
    }
  }
}

export const CategoryRelatedType: RelatedType = 'product-category'
